// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1,h2,h3,h4,h5,h6{
    font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/commanComponents/NavigationBar/Typography.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB","sourcesContent":["h1,h2,h3,h4,h5,h6{\n    font-weight: 700;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
